// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__1oJr3","text":"styles_text__g5qWW","btn":"styles_btn__3V0Ar","loading":"styles_loading__J-98I"};